import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { Language } from '../../utils';

import makeClasses from './styles';

const StatusPill = ({ data, children }) => {
  const classes = makeClasses();

  const { languageTexts } = useSelector((state) => ({
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  let statusClassName = classes.statusGrey;

  if (['ACTIVE', 'APPROVED', 'COMPLETED', 'CHARGED', 'PAYED'].includes(data)) {
    statusClassName = classes.statusGreen;
  } else if (['FAILED', 'INACTIVE', 'RENOVATION_FAILED', 'ERROR'].includes(data)) {
    statusClassName = classes.statusRed;
  } else if (['PENDING', 'IN_PROGRESS', 'APPROVED', 'PARTIAL_EXECUTED'].includes(data)) {
    statusClassName = classes.statusYellow;
  }
  console.log(statusClassName);
  return <div className={clsx(classes.status, statusClassName)}>{children || i18n.get(`Statuses.${data}`)}</div>;
};

export default StatusPill;
